import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { FadeLoader } from "react-spinners";

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        const response = await axios.get(
          `https://naqshzari.com/backend/public/api/get-blog-by-slug/${slug}`,
          {
            headers: {
              Accept: "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          setBlog(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching blog detail", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogDetail();
  }, [slug]);

  if (loading) {
    return (
      <div>
        <Header />
        <Container
          className="my-5"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "70vh",
          }}
        >
          <FadeLoader color={"#000000"} loading={loading} />
        </Container>
        <Footer />
      </div>
    );
  }

  if (!blog) {
    return (
      <div>
        <Header />
        <Container className="my-5">
          <p>Blog not found.</p>
        </Container>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="contact-section mb-5">
        <div className="contact-form-styling">
          <div className="contact-heading">{blog.title}</div>
        </div>
        <Container>
          {blog.sections &&
            blog.sections.length > 0 &&
            blog.sections.map((section, index) => (
              <Row key={index} className="mb-5">
                {index % 2 === 0 ? (
                  <>
                    <Col md={8} className="mx-auto">
                      <div className="naqsh-about">
                        <img
                          src={section.image}
                          style={{ width: "100%" }}
                          alt={`Section ${index + 1}`}
                        />
                      </div>
                    </Col>
                    <Col md={8} className="mx-auto">
                      <div
                        className="contact-form-styling"
                        dangerouslySetInnerHTML={{
                          __html: section.description,
                        }}
                      />
                    </Col>
                  </>
                ) : (
                  <>
                    <Col md={8} className="mx-auto">
                      <div className="naqsh-about">
                        <img
                          src={section.image}
                          alt={`Section ${index + 1}`}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Col>
                    <Col md={8} className="mx-auto">
                      <div
                        className="contact-form-styling"
                        dangerouslySetInnerHTML={{
                          __html: section.description,
                        }}
                      />
                    </Col>
                  </>
                )}
              </Row>
            ))}
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
